import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { T as TRANSITION_CLASSNAME_PREFIX, a as PopoverSurface, b as PopperArrow } from './Popover.styles-BPJ5Opwv.js';
import { c as createTriggerPopoverChangeEvent } from './createPopoverChangeEvent-CUr5wwDz.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { O as OnRootContainerMousedown } from '../LocalModules/storm-ui-utils/dist/esm/OnRootContainerMousedown-Bh14xj3_-BLKWZj31.js';
import { P as Portal } from '../Portal/Portal-CfuGnhf3.js';
import { c as composeRefs } from '../LocalModules/storm-ui-utils/dist/esm/composeRefs-CHPW6wJ8-CHPW6wJ8.js';
import { S as SurfaceContext } from '../SurfaceProvider/SurfaceProvider-qDGZSFCj.js';

const PopoverMetricEvent = ({
  children,
  popoverRef,
  popoverType,
  isOpen
}) => {
  const {
    parentTaktId: taktId
  } = useTaktId({});
  const prevIsOpenRef = useRef(false);
  useEffect(() => {
    // Create the function that triggers a change event when the Dropdown opens
    const triggerPopoverOpenEvent = createTriggerPopoverChangeEvent('open', popoverType, taktId);

    // Create the function that triggers a change event when the Dropdown closes
    const triggerPopoverCloseEvent = createTriggerPopoverChangeEvent('close', popoverType, taktId);
    if (isOpen && !prevIsOpenRef.current && popoverRef !== null && popoverRef !== void 0 && popoverRef.current) {
      triggerPopoverOpenEvent(popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current);
    }
    if (!isOpen && prevIsOpenRef.current && popoverRef !== null && popoverRef !== void 0 && popoverRef.current) {
      triggerPopoverCloseEvent(popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current);
    }
    prevIsOpenRef.current = isOpen !== null && isOpen !== void 0 ? isOpen : false;
  }, [isOpen, popoverType, popoverRef, taktId]);
  return children;
};
const PopoverContainer = ({
  attributes,
  children,
  disablePortal,
  focusableBody,
  forceOpen,
  handleKeyDown,
  handleKeyUp,
  handlePopoverEntered,
  handlePopoverEntering,
  handlePopoverExited,
  handleMouseEnter,
  handleMouseLeave,
  isOpen,
  onDocumentMousedown,
  setPopoverElement,
  shadowRoot,
  styles,
  variant = 'default',
  popoverRef,
  portalRef,
  position = 'top',
  transitionDuration = 0,
  popoverType = 'Popover',
  withArrow,
  arrowElementRef,
  ...rest
}) => {
  const popoverSurfaceRef = useRef(null);
  return /*#__PURE__*/React__default.createElement(CSSTransition, {
    timeout: transitionDuration,
    appear: true,
    in: forceOpen || isOpen,
    onEntered: handlePopoverEntered,
    onEntering: handlePopoverEntering,
    onExited: handlePopoverExited,
    mountOnEnter: true,
    unmountOnExit: true,
    nodeRef: popoverSurfaceRef,
    classNames: TRANSITION_CLASSNAME_PREFIX
  }, transitionState => {
    var _document;
    if (transitionState === 'exited') return null;
    return /*#__PURE__*/React__default.createElement(OnRootContainerMousedown, {
      handler: onDocumentMousedown,
      rootContainer: shadowRoot !== null && shadowRoot !== void 0 ? shadowRoot : (_document = document) === null || _document === void 0 ? void 0 : _document.documentElement
    }, /*#__PURE__*/React__default.createElement(Portal, {
      disabled: disablePortal,
      externalPortalRef: portalRef,
      transitionDuration: transitionDuration
    }, /*#__PURE__*/React__default.createElement(PopoverMetricEvent, {
      popoverRef: popoverSurfaceRef,
      popoverType: popoverType,
      isOpen: isOpen
    }, /*#__PURE__*/React__default.createElement(PopoverSurface, _extends({
      $transitionDuration: transitionDuration,
      "aria-expanded": isOpen,
      "aria-hidden": !isOpen,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      ref: composeRefs(setPopoverElement, popoverSurfaceRef, popoverRef),
      role: "dialog",
      style: styles.popper,
      $variant: variant,
      transitionState: transitionState
    }, focusableBody ? {
      tabIndex: 0
    } : {}, attributes.popper, rest), /*#__PURE__*/React__default.createElement(SurfaceContext.Provider, {
      value: {
        isInverted: variant !== 'default'
      }
    }, withArrow && /*#__PURE__*/React__default.createElement(PopperArrow, _extends({
      ref: arrowElementRef,
      style: styles.arrow,
      $variant: variant
    }, attributes.arrow)), children)))));
  });
};

export { PopoverContainer as P };
//# sourceMappingURL=PopoverContainer-BcaDuxse.js.map
